import React from "react";
import './SubUserMobileTable.scss';
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import './MobileSubUserDetails.scss'
import parse from "html-react-parser";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { getDateFormatForInput } from "utils/gridHelpers.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useProfile } from "contexts/profileContext/profileContext.js";
import { HelperActions } from "./HelperActions.js";

const MobileSubUserDetails = ({ mobileSelectedUser }) => {

    const { getUserData } = useUser();
    const { getTextByKey } = useContent();
    const { setSelectedSubUser, getSubUserData, setSubUsers, setLoading, setNumberOfUsers  } = useProfile();

    const currentPage = getSubUserData().currentPage
    const orderAscending = getSubUserData().orderAscending
    const fieldToOrder = getSubUserData().fieldToOrder
    const sizeNumber = getSubUserData().sizeNumber

    const userData = getUserData();

    let percantegeOfSpace = null;
    let sizeWithPrecenteges = null;
    if(mobileSelectedUser) {
        sizeWithPrecenteges = bytesToDisplayHelper(mobileSelectedUser.UsedSize)
        percantegeOfSpace = ((mobileSelectedUser.UsedSize/userData.UserMaxStorage) * 100).toFixed(2);
    }
    
    return (
        <>
            <AnimationContainer
                animationClassName="side-bar-animation"
            >
            {
                mobileSelectedUser ? (
                <div className="sub-user-mobile-details-container">
                    <div className="sub-user-mobile-header-details">
                        <div
                            onClick={() => setSelectedSubUser({})}
                            className="exit-icon"
                        >
                            <Icon gray name="arrow-back" />
                        </div>
                        <div className="sub-user-mobile-details-picture">
                            {parse(mobileSelectedUser.ProfilePicture)}
                        </div>
                        <div className="sub-user-mobile-details-name">
                            {mobileSelectedUser.FullName}
                        </div>
                    </div>
                    <div>
                    <HelperActions
                        details={mobileSelectedUser}
                        currentPage={currentPage}
                        sizeNumber={sizeNumber}
                        setLoading={setLoading}
                        setSubUsers={setSubUsers}
                        setNumberOfUsers={setNumberOfUsers}
                        fieldToOrder={fieldToOrder}
                        orderAscending={orderAscending}
                        isMobile={true}
                    />
                    </div>
                    <div className="sub-user-mobile-body-details">
                        <div className="details-container">
                            <div className="sub-title">
                                {getTextByKey("table-header-email")}
                            </div>
                            <div className="value">
                                {mobileSelectedUser.Email}
                            </div>
                        </div>

                        <div className="details-container">
                            <div className="sub-title">
                                {getTextByKey("table-header-lastlogin")}
                            </div>
                            <div className="value">
                                 {getDateFormatForInput(mobileSelectedUser.LastLogin)}
                            </div>
                        </div>

                        <div className="details-container">
                            <div className="sub-title">
                                {getTextByKey("table-header-permission")}
                            </div>
                            <div className="value">
                                {mobileSelectedUser.Permission}
                            </div>
                        </div>

                        <div className="details-container">
                            <div className="sub-title">
                                {getTextByKey("table-header-status")}
                            </div>
                            <div className="value">
                                {mobileSelectedUser.Status}
                            </div>
                        </div>

                        <div className="details-container">
                            <div className="sub-title">
                                {getTextByKey("table-header-usedsize")}
                            </div>
                            <div className="value">
                                {sizeWithPrecenteges ? `${sizeWithPrecenteges.size}${sizeWithPrecenteges.type} (${percantegeOfSpace}%)` : "0"}
                            </div>
                        </div>

                    </div>

                </div>
                ) : (
                    <div className="sub-user-mobile-details-no-user">
                        No user selected
                    </div>
                )
            }
            </AnimationContainer>
        </>
    )   
}

export default MobileSubUserDetails;
